import { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import useAxiosPrivate from "../../Pages/hooks/useAxiosPrivate";
import useAuth from "../../Pages/hooks/useAuth";
import { baseURL, SENDMESSAGE, CHAPTERID, YEARLESSON } from "../../API/API";
import { toast } from "react-toastify";

export default function SendMessageCart({ setmessage, message, chapterId }) {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();
  const [Lesson, setLesons] = useState([]);
  const [selectId, setSelectId] = useState("");
  const [messages, setmessages] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      if (!auth?.accessToken) {
        console.log("لا يوجد access token");
        return;
      }

      setLoading(true);
      try {
        let res;
        
        // إذا تم تحديد chapter_id، جلب الدروس الخاصة بهذا الفصل
        // وإلا جلب جميع الدروس من جميع الفصول
        if (chapterId) {
          console.log("جاري جلب الدروس للوحدة:", chapterId);
          res = await axiosPrivate.get(`${baseURL}/${CHAPTERID}/${chapterId}`);
        } else {
          console.log("جاري جلب جميع الدروس (لم يتم تحديد وحدة)");
          res = await axiosPrivate.get(`${baseURL}/${YEARLESSON}`);
        }
        
        console.log("الدروس المستقبلة:", res.data);
        const lessons = Array.isArray(res.data.data) ? res.data.data : [];
        setLesons(lessons);
        console.log("عدد الدروس:", lessons.length);
      } catch (err) {
        console.log("خطأ في جلب الدروس:", err);
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setError("غير مصرح. الرجاء تسجيل الدخول.");
        } else {
          setError("فشل تحميل الدروس");
        }
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [axiosPrivate, auth?.accessToken, chapterId]);

  async function SendData() {
    setError("");
    
    // التحقق من التوكن
    if (!auth?.accessToken) {
      setError("يجب تسجيل الدخول لإرسال الرسالة");
      return;
    }

    // التحقق من البيانات المدخلة
    if (!messages || messages.trim() === "") {
      setError("الرجاء إدخال نص الرسالة");
      return;
    }

    if (!selectId || selectId === "") {
      setError("الرجاء اختيار الدرس");
      return;
    }

    setLoading(true);
    try {
      console.log("إرسال الرسالة:", { message: messages, selectId });
      const res = await axiosPrivate.post(`${baseURL}/${SENDMESSAGE}`, {
        message: messages,
        selectId: parseInt(selectId), // تحويل إلى رقم
      });
      console.log("تم إرسال الرسالة بنجاح:", res.data);
      setmessage(false);
      setmessages("");
      setSelectId("");
      toast.success("✅ تم إرسال الرسالة بنجاح");
    } catch (err) {
      console.log("خطأ في إرسال الرسالة:", err);
      const errorMsg = err?.response?.data?.message || err?.response?.data?.Message || "فشل إرسال الرسالة";
      setError(errorMsg);
      toast.error("❌ " + errorMsg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {message && (
        <Modal
          show={message}
          onHide={() => setmessage(false)}
          centered
          dir="rtl"
        >
          <Modal.Header className="border-0 d-flex justify-content-center position-relative">
            <Modal.Title className="mx-auto">إرسال استفسار</Modal.Title>
            <div
              onClick={() => setmessage(false)}
              style={{
                position: "absolute",
                left: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                backgroundColor: "red",
                color: "white",
                borderRadius: "50%",
                width: "28px",
                height: "28px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              ×
            </div>
          </Modal.Header>

          <Modal.Body>
            {/* رسالة الخطأ */}
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            {/* حالة التحميل */}
            {loading && <div className="alert alert-info">جاري المعالجة...</div>}

            {/* اختيار الدرس */}
            <Form.Group className="mb-3">
              <Form.Label>اختر الدرس</Form.Label>
              <Form.Select
                onChange={(e) => setSelectId(e.target.value)}
                value={selectId}
                disabled={loading || Lesson.length === 0}
              >
                <option value="">--- اختر الدرس ---</option>
                {Lesson && Lesson.length > 0 ? (
                  Lesson.map((lesson) => (
                    <option key={lesson.id} value={lesson.id}>
                      {lesson.lesson_name || "درس بدون اسم"}
                    </option>
                  ))
                ) : (
                  <option disabled>لا توجد دروس متاحة</option>
                )}
              </Form.Select>
            </Form.Group>

            {/* نص الرسالة */}
            <Form.Group className="mb-3">
              <Form.Label>محتوى الرسالة</Form.Label>
              <Form.Control
                value={messages}
                onChange={(e) => setmessages(e.target.value)}
                as="textarea"
                rows={4}
                placeholder="اكتب رسالتك هنا..."
                disabled={loading}
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer className="border-0">
            <Button 
              variant="secondary" 
              onClick={() => setmessage(false)}
              disabled={loading}
            >
              إلغاء
            </Button>
            <Button 
              variant="dark" 
              onClick={SendData}
              disabled={loading}
              className="w-50"
            >
              {loading ? "جاري الإرسال..." : "إرسال"}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
